import * as React from 'react';
import StabilityIssuesContainer from '@/components/monitoring/StabilityIssuesContainer';
import { PlanRestrictedFeatureWrapper } from '@/components/planRestrictions/PlanRestrictedFeatureWrapper';
import { antGrey, runwayColors } from '@/components/styles/globalStyles';
import IntegrationIcon from '@/components/icons/IntegrationIcon';
import Text from 'antd/lib/typography/Text';
import { IntegrationType, StabilityInfo, SubscriptionFeatureType } from '@/types';

interface AppHomeStabilityIssuesSectionProps {
    appId: string;
    stabilityInfosWithIssuesSupport: StabilityInfo[];
    showStabilityIssues: boolean;
    stabilityIntegrationId?: IntegrationType;
}

const PaywalledStabilityIssuesCard: React.FC<{ integrationType?: IntegrationType }> = ({ integrationType }) => {
    return (
        <div
            style={{
                borderRadius: 4,
                border: `1px solid ${antGrey.grey5}`,
                backgroundColor: runwayColors.white,
                padding: '8px 12px',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                width: '100%',
            }}
        >
            {integrationType && <IntegrationIcon integrationId={integrationType} size={16} />}
            <Text
                style={{
                    color: antGrey.grey7,
                    fontSize: 12,
                    lineHeight: 'normal',
                }}
                ellipsis={{
                    tooltip: 'Stability issues',
                }}
            >
                Stability issues
            </Text>
            <div style={{ flexGrow: 1 }} />
            <PlanRestrictedFeatureWrapper feature={SubscriptionFeatureType.Rollouts} requiresTooltip mini />
        </div>
    );
};

export const AppHomeStabilityIssuesSection: React.FC<AppHomeStabilityIssuesSectionProps> = ({
    appId,
    stabilityInfosWithIssuesSupport,
    showStabilityIssues,
    stabilityIntegrationId,
}) => {
    const integrationType = stabilityIntegrationId ?? stabilityInfosWithIssuesSupport[0]?.integrationId;

    return (
        <PlanRestrictedFeatureWrapper feature={SubscriptionFeatureType.Rollouts}>
            {(isFeatureDisabled) => {
                if (isFeatureDisabled) {
                    return <PaywalledStabilityIssuesCard integrationType={integrationType} />;
                }

                if (showStabilityIssues) {
                    return (
                        <>
                            {stabilityInfosWithIssuesSupport.map((info) => (
                                <StabilityIssuesContainer
                                    key={`${info.integrationId}-${info.buildIdentifier ?? ''}`}
                                    appId={appId}
                                    stabilityInfo={info}
                                />
                            ))}
                        </>
                    );
                }

                return null;
            }}
        </PlanRestrictedFeatureWrapper>
    );
};
